import DescriptionDetail from "src/shared/components/data-display/description-detail/DescriptionDetail"
import Drawer from "src/shared/components/layout/drawer/Drawer"
import { formatCurrencyToFixed } from "src/shared/hooks/formatCurrency"
import { formatText, formatTextWithCapitalize } from "src/shared/hooks/formatTextOpcions"
import { capitalize } from "src/shared/helpers/capitalize"
import { VentasReservasDetailProps } from "./VentasReservasDetail.type"
import "./VentasReservasDetail.css"

const emptyValue = "-"

const VentasReservasDetail = ({ isOpen, onClose, data }: VentasReservasDetailProps): JSX.Element => {
    const metodosPago = data?.metodos_pago ? formatText(data.metodos_pago) : emptyValue

    return (
        <Drawer placement={"right"} bar={false} visible={isOpen} withCloseButton onClose={onClose} testId="ventas-reservas-detail">
            <div className="vr-detail__head">
                <p className="vr-detail__title">{data?.origen ? capitalize(data.origen) : emptyValue}</p>
                <p className="vr-detail__subtitle">
                    {data?.ticket}
                </p>
            </div>
            <div className="vr-detail__body">
                <div className="vr-detail__description">
                    <DescriptionDetail
                        icon={"FolderFill"}
                        label={"Categoría"}
                        value={data?.categoria ? formatTextWithCapitalize(data.categoria) : emptyValue}
                    />
                    <DescriptionDetail 
                        icon={"building4Fill"} 
                        label={"Habitación"} 
                        value={data?.habitacion || emptyValue} 
                    />
                    <DescriptionDetail
                        icon={"dollarCircle"}
                        label={"Total"}
                        value={data?.total ? formatCurrencyToFixed(data.total) : emptyValue}
                    />
                    <DescriptionDetail
                        className={"vr-detail__value--multiline"}
                        icon={"creditCard"}
                        label={"Método de pago"}
                        value={metodosPago}
                    />
                    <DescriptionDetail
                        icon={"calendarFill"}
                        label={"Fecha"}
                        value={data?.fecha || emptyValue}
                    />
                    <DescriptionDetail
                        icon={"FileListFill"}
                        label={"Turno"}
                        value={data?.turno || emptyValue}
                    />
                    <DescriptionDetail
                        className={"vr-detail__value--full"}
                        icon={"userFilled"}
                        label={"Atendió"}
                        value={data?.atiende || emptyValue}
                    />
                    <DescriptionDetail
                        className={"vr-detail__value--full"}
                        icon={"userFilled"}
                        label={"Cobró"}
                        value={data?.cobra || emptyValue}
                    />
                </div>
            </div>
        </Drawer>
    )
}

export default VentasReservasDetail
